export const getPrismicTime = value => {
  return Date.parse(value);
};

export const getPrismicDate = (value = "") => {
  return new Date(value.replace(/-/g, "/").replace("T", " "));
};
